import React, { useEffect, useState } from "react";
import "./Abas.scss";

export default function Abas(props) {
  const [titleActive, setTitleActive] = useState();
  const [corpoActive, setCorpoActive] = useState([]);

  useEffect(() => {
    handleClick(props.titleActive);
  }, []);

  const handleClick = (item) => {
    if (!item.permissoes) {
      return;
    }
    setTitleActive(item?.title); //Ativa a aba
    const corpoActive = props.corpo.filter((x) => x.title === item?.title);
    setCorpoActive(...corpoActive); //Ativa o body
  };

  useEffect(() => {
    if (props.corpo.length > 0) {
      let corpo = [];
      if (titleActive) {
        corpo = props.corpo.filter((x) => x.title === titleActive);
      } else {
        corpo = props.corpo.filter((x) => x.default === true);
      }
      setCorpoActive(...corpo); //Ativa o body
    }
  }, [props.corpo]);

  return (
    <div className="abas">
      <div className="abas-titles">
        {props.corpo.map((item, index) => (
          <div
            onClick={() => {
              handleClick(item);
              if (typeof item?.handleExecute === "function") {
                item.handleExecute();
              }
            }}
            data-tooltip-id="tooltip-001"
            data-tooltip-content={
              !item?.permissoes
                ? "Você não possui permissão para acessar esta área."
                : ""
            }
            className={`abas-title-individual ${
              titleActive === (item?.title || item?.default) && item?.permissoes
                ? "active"
                : "" //Ativa pelo titleActive ou pelo default
            } ${!item?.permissoes ? "disabled" : ""}`}
            key={index}
            style={{
              backgroundColor: item?.background,
              color: item?.colorTitle,
            }}
          >
            {item.title}
          </div>
        ))}
      </div>

      <div
        style={{
          backgroundColor: corpoActive?.background,
        }}
        className={`abas-corpo ${!corpoActive?.permissoes ? "disabled" : ""}`}
      >
        {!corpoActive?.permissoes && (
          <p className="abas-corpo-permissoes">
            Você não possui permissão para acessar esta área.
          </p>
        )}
        <div
          style={{
            filter: !corpoActive?.permissoes ? "blur(4px)" : "",
            pointerEvents: !corpoActive?.permissoes ? "none" : "",
          }}
        >
          {/* o body ativado */}
          {corpoActive?.body}
        </div>
      </div>
    </div>
  );
}

Abas.defaultProps = {
  id: "",
  className: "",
  theme: "1",
  titleActive: "View",
  corpo: [
    {
      title: "View",
      ShowGrid: false,
      body: <div>teste</div>,
      background: "#4E495D",
      handleExecute: () => {},
      default: true,
    },
    {
      title: "Processando",
      ShowGrid: false,
      body: <div>teste</div>,
      handleExecute: () => {},
      background: "#FF9F3B",
    },
  ],
};
